import type { Post } from "@shared/schema";

export interface CompetitorInfo {
  competitorName: string;
  postsThisWeek: number;
  postsThisMonth: number;
  lastPostDate: string | null;
  threatLevel: "high" | "medium" | "low";
  keywordsDetected: string[];
}

export interface CompetitorPressure {
  state: "winning" | "falling_behind" | "critical";
  headline: string;
  subtext: string;
  color: string;
  clientPostsThisWeek: number;
  avgCompetitorPosts: number;
  daysSinceLastPost: number;
  competitors: CompetitorInfo[];
}

export interface GenerateResponse {
  count: number;
}

export interface PublishResponse {
  published: boolean;
  message?: string;
}

export interface ImageGenerateResponse {
  imageUrl?: string | null;
  prompt?: string;
  source?: string;
  message?: string;
}

export interface PostSavePayload {
  locationId: string;
  title?: string;
  content: string;
  postType: string;
  status: string;
  scheduledAt?: string;
  couponCode?: string;
  eventStartDate?: string;
  eventEndDate?: string;
  ctaType?: string;
  ctaUrl?: string;
  mediaUrl?: string;
  tags: string[];
  approvalStatus: string;
}

export type PostWithTags = Post & {
  tags: string[];
};

export function getPostTags(post: Post): string[] {
  const tags = (post as PostWithTags).tags;
  return Array.isArray(tags) ? tags : [];
}
